"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
/*!
  Copyright (c) 2019 DynAgility LLC. All rights reserved.
  Licensed under the MIT License.
*/
var react_1 = require("react");
var redux_react_hook_1 = require("redux-react-hook");
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var constants_1 = require("./constants");
var successAuth = function (user) { return ({ type: constants_1.SUCCESS_AUTH, user: user }); };
var failAuth = function (error) { return ({ type: constants_1.FAIL_AUTH, error: error }); };
exports.DefaultAuthStrategy = {
    getRequestOptions: function (method, body) { return ({ method: method, body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } }); },
    onUnauthorized: function (dispatch, getState, request) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(failAuth(request));
            return [2 /*return*/, false];
        });
    }); },
    onForbidden: function (dispatch, getState, request) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(failAuth(request));
            return [2 /*return*/, false];
        });
    }); },
    authenticate: function (dispatch, credentials) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); }
};
var JWTAuthStrategy = /** @class */ (function () {
    function JWTAuthStrategy(authenticateUserUrl, refreshJWTUrl) {
        this.authenticateUserUrl = authenticateUserUrl;
        this.refreshJWTUrl = refreshJWTUrl;
    }
    JWTAuthStrategy.prototype.tryRefreshJWT = function (dispatch, getState, request) {
        return __awaiter(this, void 0, void 0, function () {
            var request_1, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.refreshJWTUrl !== undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetch(this.refreshJWTUrl, { headers: { 'Authorization': "BEARER " + this.jwt } })];
                    case 1:
                        request_1 = _a.sent();
                        if (!(request_1.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, request_1.json()];
                    case 2:
                        response = _a.sent();
                        this.jwt = response.jwt;
                        return [2 /*return*/, true];
                    case 3:
                        this.jwt = undefined;
                        dispatch(failAuth(request));
                        return [2 /*return*/, false];
                }
            });
        });
    };
    JWTAuthStrategy.prototype.getRequestOptions = function (method, body) {
        var headers = { 'Content-Type': 'application/json' };
        if (this.jwt !== undefined) {
            headers['Authorization'] = "BEARER " + this.jwt;
        }
        return {
            method: method,
            body: JSON.stringify(body),
            headers: headers
        };
    };
    JWTAuthStrategy.prototype.authenticate = function (dispatch, credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var request, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, fetch(this.authenticateUserUrl, { method: 'POST', body: JSON.stringify(credentials), headers: { 'Content-Type': 'application/json' } })];
                    case 1:
                        request = _d.sent();
                        if (!(request.status === 200)) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, request.text()];
                    case 2:
                        _a.jwt = _d.sent();
                        dispatch(successAuth(jsonwebtoken_1.default.decode(this.jwt)));
                        return [3 /*break*/, 5];
                    case 3:
                        _b = dispatch;
                        _c = failAuth;
                        return [4 /*yield*/, request.json()];
                    case 4:
                        _b.apply(void 0, [_c.apply(void 0, [_d.sent()])]);
                        _d.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    JWTAuthStrategy.prototype.onUnauthorized = function (dispatch, getState, request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.tryRefreshJWT(dispatch, getState, request)];
            });
        });
    };
    JWTAuthStrategy.prototype.onForbidden = function (dispatch, getState, request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.tryRefreshJWT(dispatch, getState, request)];
            });
        });
    };
    return JWTAuthStrategy;
}());
exports.JWTAuthStrategy = JWTAuthStrategy;
exports.AuthContext = react_1.createContext(exports.DefaultAuthStrategy);
exports.AuthReducer = function (state, action) {
    if (state === void 0) { state = null; }
    if (action.type === 'SUCCESS_AUTH') {
        return action.user;
    }
    else if (action.type === 'FAIL_AUTH') {
        return null;
    }
    return state;
};
exports.mapUser = function () { return redux_react_hook_1.useMappedState(react_1.useCallback(function (state) { return state.auth; }, [])); };
